import { HTTPService } from "./service";

//GET Greenscore
export const getGS = async ({ upcCode }) => {
  const params = {}

  if (upcCode) {
    params.upcCode = upcCode
  }

  return await HTTPService({
    method: "GET",
    url: `/ProductTableMergeds/getTotalGS`,
    params: params,
  });
};

// GET PRODUCT DATA
export const getProductData = async ({ upcCode }) => {
  const params = {}

  if (upcCode) {
    params.upcCode = upcCode
    params.activegs = 1
  }

  return await HTTPService({
    method: "GET",
    url: `/ProductTableMergeds/getProductData`,
    params: params,
  });
};

//GET PRODUCT DATA FROM URL
export const getProductDataFromUrl = async ({ url }) => {
  const params = {}

  if (url) {
    params.productName = url
    params.activegs = 1
  }

  return await HTTPService({
    method: "GET",
    url: `/ProductTableMergeds/getProductData`,
    params: params,
  });
};

// GET OTHER PRODUCT DATA
export const getOtherProductData = async ({ productName }) => {
  return await HTTPService({
    method: "GET",
    url: `/ProductTableMergeds/getProductOtherData?productName=${productName}&activegs=1`,
  });
};

// GET BETTER-FOR-YOU OPTIONS
export const getBFY = async ({ upcCode, client, location }) => {
  const queryParams = {
    upcCode,
    client: location ? "provisions" : client,
    online: client === "mfc" ? 1 : 0,
    location
  };

  try {
    const response = await HTTPService({
      method: "GET",
      url: `/ProductTableMergeds/getBetterForYouProductsUPC`,
      params: queryParams,
    });
    return response;
  } catch (error) {
    console.error("Error fetching related products:", error);
    throw error;
  }
}

//Get scores
export const getScores = async ({ upcCode }) => {
  return await HTTPService({
    method: "GET",
    url: `/ProductTableMergeds/getAllGS?upcCode=${upcCode}`,
  });
};


// Get locations
export async function getStoreLocation(location) {
  try {
    const res = await HTTPService({
      method: "GET",
      url: `/ProductTableMergeds/getAllLocations?client=${location}`,
    });
    return res;
  } catch (err) {
    if (err.response?.status === 404) throw new Error('Store not found');
    throw err;
  }
}